import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Delegate } from '../../models/delegate';
import { DelegateService } from '../../services/delegate.service';
import { CommitteeService } from '../../services/committee.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-delegation',
  templateUrl: './delegation.component.html',
  styleUrls: ['./delegation.component.css']
})
export class DelegationComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerDelegate: PageHeader;
  entity: Delegate = new Delegate();
  selectedDelegate: Delegate = new Delegate();
  editingEntity: Delegate = new Delegate();
  Delegate: any;
  DelegateColumns: any[];
  listView: boolean = true;
  formCaption: string = '';
  locations: Array<Location> = [];
  selectedLocation: any;
  _selectedDelegate: any;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  departments: Array<Department> = [];
  pipe = new DatePipe('en-US');
  constructor(
    private _departmentService: DepartmentService,
    private _DelegateService: DelegateService,
    private _committeeService: CommitteeService,
    private _locationService: LocationService,
    private _employeeService: EmployeeService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerDelegate = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.DelegateColumns = [
      { field: "SlNo", title: 'SL No', filter: false, sortable: true},
      { field: "DelegationName", title: 'Delegate Name', filter: true, sortable: true },
      { field: "DelegationDescription", title: 'Description ', filter: true, sortable: true },
      { field: "Active", title: 'Active', filter: true, sortable: true },

    ];

    this.Delegate = [];
    this.getAllDelegate();

  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._DelegateService.getAllDelegate('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((Delegate: Array<Delegate>) => {
      this.Delegate = {
        data: Delegate,
        total: Delegate[0] ? Delegate[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._DelegateService.getAllDelegate(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((Delegate: Array<Delegate>) => {
        this.Delegate = {
          data: Delegate,
          total: Delegate[0] ? Delegate[0].TotalCount : 0
        }
      });
    }
  }
  getAllDelegate() {
    this._DelegateService.getAllDelegate('', Number(this.defaultPageSize), 1, 0, 0).subscribe((Delegate: Array<Delegate>) => {
      this.Delegate.DateOfFormation = new Date(this.Delegate.DateOfFormation)

      this.Delegate = Delegate;
      for (let i = 0; i < Delegate.length; i++) {
        this.Delegate[i].DateOfFormation = this.pipe.transform(this.Delegate[i].DateOfFormation, "dd/MM/yyyy");


      }
      this.Delegate = {

        data: Delegate,
        total: Delegate[0] ? Delegate[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._DelegateService.deleteDelegate(this.selectedDelegate.Delegation_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearDelegate();
            this.getAllDelegate();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerDelegate = new PageHeader();
    headerDelegate.PageCaption = "Delegation";
    headerDelegate.IconClass = "bi bi-shield-shaded";
    return headerDelegate;
  }

  deleteDelegate(event: any) {
    if (event.seletedRows[0]) {
      this.selectedDelegate.Delegation_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Delegate",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addDelegate(event: any) {
    this.listView = false;
    this.clearDelegate();
    this.formCaption = "Add Delegate";
  }

  editDelegate(event: any): void {
    if (event.seletedRows[0]) {
      this._DelegateService.viewDelegate(event.seletedRows[0]).subscribe((Delegate: Array<Delegate>) => {
        let editEnity = Delegate[0] ? Delegate[0] : new this.Delegate();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Delegate";
          this.entity.EntityMetaData = [
            { FieldName: 'DelegationName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Delegate Name is required' },
            //{ FieldName: 'DelegationDescription', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Delegate Code is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    //this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._DelegateService.checkDuplication(this.entity.DelegationName, this.entity.Delegation_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Delegate already exists');
          this.saveDisabled = false;
        }
        else {
          this._DelegateService.saveDelegate(this.entity).subscribe(() => {
            if (this.entity.Delegation_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearDelegate();
            this.getAllDelegate();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }


  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }

  gotoBack(): void {
    this.listView = true;
    this.getAllDelegate();
  }

  refreshDelegate(event: any): void {
    this.Delegate = [];
    this.getAllDelegate();
  }

  clearDelegate(): void {
    this._selectedDelegate = {};
    this.entity = new Delegate();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

